import { createSlice } from "@reduxjs/toolkit";

const initialState ={
    counterValue: 0,
}

const counterSlice = createSlice({
    name: 'counter',
    initialState: initialState,
    reducers: {
        increment: (state, action) => {
            state.counterValue++;
        },
        decrement: (state) => {
            state.counterValue--;
        },
        incrementByAmount: (state, action) => {
            state.counterValue = state.counterValue + action.payload;
        }
    }
})

export default counterSlice.reducer;
export const {increment, decrement, incrementByAmount} = counterSlice.actions;